export const needCommaInText = (contract_number: string, contract_date: string) => {
    if (contract_number && contract_date) {
        return `${contract_number}, ${contract_date}`;
    }
    return contract_number || contract_date;
};
